import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useGetUser } from 'app/api/hooks/core/v1/auth/user';
import { routes } from 'app/constants/routes';
import LoadingScreen from 'app/pages/shared/LoadingScreen';
import { snakecase } from 'app/utils/lib/case-conversion';
import { getFirstMissingDetail } from 'app/utils/lib/user';

// Local Typings
interface Props {
  returnUrl: string;
}

// Component Definition
const MissingDetailsValidator: FC<PropsWithChildren<Props>> = props => {
  const user = useGetUser();

  if (!user) {
    return <LoadingScreen />;
  }

  const isOnMissingDetailsPage = window.location.pathname.toLowerCase()
    .startsWith(`/${routes.missingDetails}`.toLowerCase());

  const missingDetail = getFirstMissingDetail(user);

  if (missingDetail && !isOnMissingDetailsPage) {
    return <Navigate to={`/${routes.missingDetails}/${snakecase(missingDetail)}${props.returnUrl}`} />;
  }

  return props.children;
};

export default MissingDetailsValidator;
